<template>
  <v-dialog
    v-model="show"
    :max-width="579"
    @click:outside="$emit('hideModal')"
    @keydown.esc="$emit('hideModal')"
  >
    <v-card>
      <v-card-text class="text-left pt-6">
        <p class="h6 pt-2 blue-grey--text text--darken-3">
          {{ title }}
        </p>
        <p class="body-1 mb-6 blue-grey--text text--darken-1">{{ subtitle }}</p>
        <div class="relative d-flex" v-if="!onlyShowMessage">
          <UserAvatar
            v-if="account"
            size="36px"
            fontSize="12px"
            class="mr-4"
            :account="account"
          />
          <v-textarea
            rows="3"
            v-model="reason"
            outlined
            no-resize
            :placeholder="placeholder"
          >
          </v-textarea>
        </div>
        <div class="d-flex justify-end pt-4">
          <Button
            v-if="!onlyShowMessage"
            plain
            class="pr-8"
            color="grey"
            data-testid="changedModalStatus-button-skip"
            :text="$t('common.button.skip')"
            @click="handleSubmit"
          />
          <Button
            color="primary"
            data-testid="changedModalStatus-button-send"
            :text="
              onlyShowMessage
                ? $t('common.button.close')
                : $t('common.button.send')
            "
            @click="handleSubmit"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import UserAvatar from '@/components/UserAvatar.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'ChangedModalStatus',

  components: {
    UserAvatar,
    Button,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    status: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    onlyShowMessage: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      reason: null,
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('updateModalStatus', {
        status: this.status,
        reason: this.reason,
      })
      this.$emit('hideModal')
    },
  },
  computed: {
    ...mapGetters(['account']),
  },
}
</script>
